<template>
    <div class="flex flex-col items-center gap-4 text-center">
        <div class="flex flex-col gap-2 max-w-xl">
            <p class="body-small text-ink-muted">
                Teammates ask for your anonymous input — it shapes their reflection just like theirs shapes yours. Each round takes just a few minutes.
            </p>
        </div>

        <ol class="flex flex-col gap-4 w-full max-w-xl text-left">
            <li v-for="step in steps" :key="step.n" class="flex items-start gap-3">
                <span class="flex items-center justify-center w-7 h-7 shrink-0 rounded-full bg-surface-sunken body-small-bold text-ink-muted">
                    {{ step.n }}
                </span>
                <p class="body-small text-ink-muted">
                    <span class="body-small-bold text-ink">{{ step.title }}</span>
                    {{ step.body }}
                </p>
            </li>
        </ol>
    </div>
</template>

<script setup lang="ts">
// No `Launch` CTA: raters can't proactively give feedback — they respond to
// invites teammates send, which appear as rows on the tab itself.
const steps = [
    { n: 1, title: "Requests come in:", body: "when a teammate asks for feedback, it appears here." },
    { n: 2, title: "Answer quickly:", body: "a short, anonymous set of questions per request." },
    { n: 3, title: "It stays confidential:", body: "your name stays off their report." },
];
</script>
